import { getMySchedules } from "routes/schedule/my-schedules/my-custom-schedules/controller/get-my-schedules"
import { useReference } from "lib/@hooks/use-reference"

export function useMySchedules({
    sortMode = "modified_descending",
    drafts = true,
    retired = false,
    published = true,
    skip = 0,
    limit = 50,
    search,
}) {
    const [{ filterModes }] = useReference({ filterModes: {} }, "filter")

    const data = getMySchedules.useResults.debounce(100, {
        drafts,
        retired,
        published,
        skip,
        limit,
        search,
        sortMode,
        ...filterModes,
    })
    return [data, !data]
}
